import { render, staticRenderFns } from "./SpreadProtocol.vue?vue&type=template&id=101ab6be&"
import script from "./SpreadProtocol.vue?vue&type=script&lang=js&"
export * from "./SpreadProtocol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports